import { Component, HostListener, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LobbyPage, pageNameToPath, lobbyPages } from '../../models/navigation.model';
import { NavigationService } from '../../services/navigation.service';
import { UsersService } from '../../services/users.service';
import { AssignedService } from '../../services/assigned.service';
import { combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AssignmentService } from '../../services/assignment.service';
import { BusinessService } from '../../services/business.service';
import { Assigned } from "../../models/assigned.model";
import { Assignment } from "../../models/assignment.model";
import { ScheduleService } from "../../services/schedule.service";
import { LobbyService } from "../../services/lobby.service";
import { OnboardingService } from '../../services/onboarding.service';
import { ViewAsService } from "../../services/view-as.service";
import { OnboardingBannerComponent } from "../../components/onboarding-banner/onboarding-banner.component";

@Component({
    selector: 'app-lobby',
    templateUrl: './lobby.component.html',
    styleUrls: ['./lobby.component.scss']
})
export class LobbyComponent {

    @ViewChild('banner') banner!: OnboardingBannerComponent;
    private touchStartY: number | null = null;

    loading$ = this.businessService.selectedBusiness$.pipe(
        map(b => !b),
        startWith(true)
    );

    pages$ = combineLatest([this.usersService.currentUser$, this.viewAsService.selectedUsersIds$, this.assignedService.items$, this.assignmentService.items$]).pipe(
        map(([currentUser, selectedUsers, assigned, assignment]) => {
            let pages = Array.from(lobbyPages);
            pages = pages.filter(p => p !== 'Assigned');
            pages = pages.filter(p => p !== 'Assignment');
            if(selectedUsers && selectedUsers.length === 1 && selectedUsers[0] === currentUser.id) {
                if (assignment.length > 0) {
                    if(this.hasDeniedOrOverdueAssignment(assignment))
                        (pages as any).unshift({tab: 'Assignment', class: 'red'});
                    else
                        pages.unshift('Assignment')
                }
                if (assigned.length > 0) {
                    if(this.hasDeniedOrOverdueAssigned(assigned))
                        (pages as any).unshift({tab: 'Assigned', class: 'red'});
                    else
                        pages.unshift('Assigned')
                }
            }
            return pages as LobbyPage[];
        })
    );

    page$ = this.navigationService.page$;

    user$ = this.authService.user$;

    bannerData$ = this.onboardingService.onboardingData$;

    constructor(
        private authService: AuthService,
        private businessService: BusinessService,
        private viewAsService: ViewAsService,
        private navigationService: NavigationService<LobbyPage>,
        public usersService: UsersService,
        public scheduleService: ScheduleService,
        public assignedService: AssignedService,
        public assignmentService: AssignmentService,
        public lobbyService: LobbyService,
        public onboardingService: OnboardingService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    hasDeniedOrOverdueAssigned(items: Assigned[]) {
        for(const item of items) {
            if(item.outStartTime.getTime() < Date.now())
                return true;
            if(item.type === 'assessment' || item.type === 'lead')
                return item.denied;
            if(!!item.assignedToUsers!.find(user => user.status === 'denied'))
                return true;
        }
        return false;
    }

    hasDeniedOrOverdueAssignment(items: Assignment[]) {
        for(const item of items) {
            if(item.denied || item.outStartTime.getTime() < Date.now())
                return true;
        }
        return false;
    }

    onTabSelected(tab: string) {
        const page = pageNameToPath(tab as LobbyPage);
        this.scheduleService.showCalendarSubject.next(false);
        this.router.navigate([page], {relativeTo: this.route});
    }

    // Scroll detection for banner visibility
    // Desktop scroll detection
    @HostListener('wheel', ['$event'])
    onWheel(event: WheelEvent) {
        event.preventDefault();
        this.handleScrollAttempt(event.deltaY > 0 ? 'down' : 'up');
    }

    // Mobile scroll detection - Touch start
    @HostListener('touchstart', ['$event'])
    onTouchStart(event: TouchEvent) {
        this.touchStartY = event.touches[0].clientY;
    }

    // Mobile scroll detection - Touch move
    @HostListener('touchmove', ['$event'])
    onTouchMove(event: TouchEvent) {
        event.preventDefault();
        if (this.touchStartY !== null) {
            const touchY = event.touches[0].clientY;
            const deltaY = this.touchStartY - touchY;

            if (Math.abs(deltaY) > 10) { // Small threshold to avoid detecting tiny movements
                this.handleScrollAttempt(deltaY > 0 ? 'down' : 'up');
                this.touchStartY = touchY; // Update for continuous detection
            }
        }
    }

    // Mobile scroll detection - Touch end
    @HostListener('touchend')
    onTouchEnd(){
        this.touchStartY = null;
    }

    private handleScrollAttempt(direction: 'up' | 'down') {
        if(!!this.banner && direction === 'down' && this.banner.isExpanded) {
            this.banner.collapse();
        }
    }


}
